import { createReducer } from './util';
import state from '../state';
function toTop(state, action) {
  window.scrollTo(0, 0);
  return { ...state };
}
export default createReducer({ 'toTop': toTop }, state);
